import { render, staticRenderFns } from "./LanceRegistroStatus.vue?vue&type=template&id=6efa4aee"
import script from "./LanceRegistroStatus.vue?vue&type=script&lang=js"
export * from "./LanceRegistroStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports